
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sentry-example-page",
      function () {
        return require("private-next-pages/sentry-example-page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sentry-example-page"])
      });
    }
  